import { patchRequest, postRequest } from "@react/helpers/fetch"

export const updateRetention = (projectId, body) =>
  patchRequest({ url: `/projects/${projectId}/retention.json`, body })

export const releaseRetention = (projectId, body = {}) =>
  postRequest({ url: `/projects/${projectId}/retention/release.json`, body })

export const resetRetention = (projectId) =>
  postRequest({ url: `/projects/${projectId}/retention/reset.json`, body: {} })
